// extracted by mini-css-extract-plugin
export var btn = "LoginState-module--btn--3pvbB";
export var root = "LoginState-module--root--7W4Il";
export var welcome = "LoginState-module--welcome--X181f";